import React, { useContext, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import ChiamaWeb, { CChiamaWebParametri } from "../../../ChiamaWeb";
import * as Dati from "../../../Dati";
import * as DatiFide from "../../../DatiFide";
import { _LimitChart, _PieChart } from "../../components";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface IChartsTabProps {
    ID_FideAffidamento: string;
}

export const _ChartsTab: React.FC<IChartsTabProps> = ({ ID_FideAffidamento }) => {
    const { ShowDialog } = useContext(AlertDialogContext);

    const [Limits, setLimits] = useState<DatiFide.CDatiFideAffidamentoLimite>(new DatiFide.CDatiFideAffidamentoLimite());
    const [Usage, setUsage] = useState<Dati.Dictionary<number>>({});

    const onApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fideaffidamento/GetLimiti?ID_FideAffidamento=${ID_FideAffidamento}`,
            OnRis: (sender: ChiamaWeb, data: DatiFide.CRisAPIListaLimitiFideAffidamento) => {
                if (data.Dato) {
                    setLimits(data.Dato);
                }
            },
            OnErrore: (sender: ChiamaWeb, errore: Error) => onApiError(errore)
        };
        new ChiamaWeb().Chiama(Param);
    }, []);

    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fideaffidamento/GetUtilizzoPerProdotto?ID_FideAffidamento=${ID_FideAffidamento}`,
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIDizionario<number>) => {
                if (data.Dati) {
                    setUsage(data.Dati);
                }
            },
            OnErrore: (sender: ChiamaWeb, errore: Error) => onApiError(errore)
        };
        new ChiamaWeb().Chiama(Param);
    }, []);

    return (
        <Grid container justify="space-around">
            <Grid item xs={8} md={5}>
                <_LimitChart
                    Title="Utilizzo affidamento"
                    UsedVal={Limits.LimiteMassimoContraenteUtilizzato}
                    LeftVal={Limits.LimiteMassimoContraente - Limits.LimiteMassimoContraenteUtilizzato}
                    UsedLabel="Limite utilizzato"
                    LeftLabel="Limite rimasto"
                />
            </Grid>
            <Grid item xs={8} md={5}>
                <_PieChart Title="Prodotti emessi" Data={Usage} />
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsList/ChartsTab.tsx